// src/Login.jsx
import { useState } from 'react';
import { login } from './services/api';
import Logo from './components/Logo';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!username || !password) {
      setError('Bitte Benutzername und Passwort eingeben');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const success = await login(username, password);
      if (success) {
        onLogin();
      } else {
        setError('Login fehlgeschlagen');
      }
    } catch (error) {
      setError('Login-Fehler: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, var(--secondary-pink-light), var(--white))'
    }}>
      <div style={{
        background: 'var(--white)',
        padding: '48px',
        borderRadius: '12px',
        boxShadow: 'var(--shadow)',
        width: '100%',
        maxWidth: '400px',
        textAlign: 'center'
      }}>
        {/* Logo */}
        <div style={{ 
          marginBottom: '32px',
          display: 'flex',
          justifyContent: 'center'
        }}>
          <Logo size="large" showText={true} />
        </div>
        
        {/* <h2 style={{ marginBottom: '24px', color: 'var(--text-dark)' }}>
          Anmelden
        </h2> */}

        {error && (
          <div style={{
            color: 'var(--primary-coral)',
            background: 'var(--secondary-pink-light)',
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '16px'
          }}>
            {error}
          </div>
        )}

        <div style={{ marginBottom: '16px' }}>
          <input
            type="text"
            placeholder="Benutzername"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            onKeyPress={handleKeyPress}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid var(--medium-gray)'
            }}
          />
        </div>

        <div style={{ marginBottom: '24px' }}>
          <input
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            style={{
              width: '100%',
              padding: '12px',
              borderRadius: '6px',
              border: '1px solid var(--medium-gray)'
            }}
          />
        </div>

        <button
          onClick={handleLogin}
          disabled={loading}
          style={{
            width: '100%',
            padding: '12px',
            background: loading ? 'var(--medium-gray)' : 'var(--primary-coral)',
            color: 'var(--white)',
            border: 'none',
            borderRadius: '6px',
            cursor: loading ? 'not-allowed' : 'pointer',
            fontSize: '16px',
            fontWeight: '600'
          }}
        >
          {loading ? 'Anmeldung läuft...' : 'Anmelden'}
        </button>
      </div>
    </div>
  );
};

export default Login;
